import styled from "styled-components";
import { theme } from "../../../theme/GlobalTheme";

export const Container = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const ContentCard = styled.div`
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.card};
  padding: ${theme.spacing.xl};
  margin-bottom: ${theme.spacing.lg};
`;

export const Title = styled.h1`
  font-size: ${theme.typography.fontSize.h2};
  color: ${theme.colors.primary};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  margin: 0 0 ${theme.spacing.md} 0;
  text-align: left;
`;

export const InfoRow = styled.div`
  margin-bottom: ${theme.spacing.sm};
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.text};
  font-family: ${theme.typography.fontFamily};
  line-height: 1.5;
`;

export const Label = styled.span`
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.textPrimary};
`;

export const Value = styled.span`
  color: ${theme.colors.text};
`;

export const JsonContainer = styled.div`
  background-color: #f8f9fa;
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.md};
  margin: ${theme.spacing.xs} 0 ${theme.spacing.md} 0;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  overflow-x: auto;
  max-height: 400px;
  overflow-y: auto;
  
  /* Prevent layout shifts from ReactJson hover effects */
  .react-json-view {
    line-height: 1.3 !important;
  }
  
  .object-key-val {
    min-height: 20px !important;
  }
  
  .click-to-copy {
    position: relative !important;
    display: inline-block !important;
    vertical-align: top !important;
  }
  
  .copy-to-clipboard-container {
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
    opacity: 0 !important;
    transition: opacity 0.2s ease !important;
    pointer-events: none !important;
  }
  
  .object-key-val:hover .copy-to-clipboard-container {
    opacity: 1 !important;
    pointer-events: auto !important;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  margin: ${theme.spacing.lg} 0 0 0;
  flex-wrap: wrap;

  @media (max-width: ${theme.breakpoints.mobile}) {
    flex-direction: column;
  }
`;

export const Button = styled.button`
  border: none;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  padding: 15px 20px;
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-width: 180px;

  &:hover {
    background-color: ${theme.colors.secondary};
    transform: translateY(-1px);
    box-shadow: ${theme.shadows.light};
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

export const BackLink = styled.a`
  color: ${theme.colors.primary};
  text-decoration: none;
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: ${theme.typography.fontSize.body};
  font-family: ${theme.typography.fontFamily};
  margin-bottom: ${theme.spacing.md};
  display: inline-flex;
  align-items: center;
  transition: color 0.2s ease-in-out;

  &:visited {
    color: ${theme.colors.primary};
  }

  &:hover {
    color: ${theme.colors.secondary};
    text-decoration: underline;
  }

  &::before {
    content: "← ";
    margin-right: ${theme.spacing.xs};
  }
`;

export const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.text};
  font-family: ${theme.typography.fontFamily};
`;

export const NotFound = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  text-align: center;
  padding: ${theme.spacing.xl};
  
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.card};
`;